import { Box } from '@mui/material';
import React from 'react';

import { InfoOutlinedIcon, Tooltip, Typography } from '@occc/ui-design-system';

type FieldTitleProps = {
  label: string;
  infoText?: string;
  infoEnabled?: boolean;
};

export const FieldTitle = ({ label, infoText = '', infoEnabled }: FieldTitleProps) => (
  <Box display='flex' minHeight={20}>
    <Typography variant='subtitle1'>{label}</Typography>
    {infoEnabled && (
      <Tooltip title={infoText} placement='top'>
        <InfoOutlinedIcon fontSize='small' color='action' sx={{ marginLeft: 0.5 }} />
      </Tooltip>
    )}
  </Box>
);
